<div class="c08-browse-title-slider" #c08BrowseTitlesRef>
  <h2 class="sliders-title" data-animation="sliders-title" [class.active]="isActive">
    {{ sliderTitle }}
  </h2>
  <div class="browse-titles-slider" #slider>
    <figure
      *ngFor="let movieTile of movieTiles"
      [ngClass]="movieTile.active ? 'movie-tile active' : 'movie-tile'"
    >
      <img class="tile-img" src="{{ movieTile.src }}" alt="" />
      <div class="tile-info-wrapper">
        <h3 class="title-title">{{ movieTile.name }}</h3>
        <div class="tile-platform-wrapper" aria-hidden="true">
          <p class="tile-platform-copy">{{ movieTile.platform }}</p>
          <img
            class="tomato-icon"
            src="{{ '/assets/images/icons/RottenTomatoes.svg' | assetpipe }}"
            alt=""
          />
          <p class="tile-platform-rating" aria-hidden="true">{{ movieTile.rating }}</p>
        </div>
      </div>
    </figure>
    <div aria-live="polite" class="screen-reader-movie">{{ activeMovieDescription }}</div>
  </div>
</div>
